module.exports = __webpack_public_path__ + "img/building.643b5f63.svg";